import { Amplify } from 'aws-amplify';

const awsConfig = {
  // Add any specific hosting configuration if needed
};

// Initialize Amplify
Amplify.configure(awsConfig);

export default Amplify; 